import { api } from '@/src/shared/lib/api'

export async function videoProfilesCategoryListGet<ApiResponse>() {
  const url = api.appURL('video/profiles/category/list')

  const response = await api.get<ApiResponse>(url)
  return api.parseRespone<ApiResponse>(response)
}
